import { ReactComponent as CheckIcon } from '../../../../../../../../icons/checkboxIcon.svg'
import { getImageFormat } from '../../../../../../../../utils/getImageFormat'

import { CARD_TYPE_IMGS, CARD_TYPE_ORDER } from './constants'
import styles from './Card.module.scss'
import React from 'react'
export const Card = ({ item, payment_method_id, handleSelectPm }) => {
  const selected = payment_method_id === item?.id

  if (!item) return null

  return (
    <div className={styles.root} data-testid="card-root">
      <img
        className={
          selected ? `${styles.image} ${styles.selected}` : styles.image
        }
        src={getImageFormat(item.image_url, '_')}
        alt="img"
        onClick={() => handleSelectPm(item)}
        data-testid="card-img"
      />

      {selected && (
        <div className={styles.checkedIcon} data-testid="card-checked">
          <CheckIcon />
        </div>
      )}

      {!!item.card_type?.length && (
        <div className={styles.badgesBox} data-testid="card-badgesBox">
          {item.card_type
            .filter((type) => CARD_TYPE_ORDER.includes(type))
            .sort(
              (a, b) => CARD_TYPE_ORDER.indexOf(a) - CARD_TYPE_ORDER.indexOf(b)
            )
            .map((type) => {
              const image = CARD_TYPE_IMGS[type]
              return (
                image && (
                  <img
                    key={type}
                    src={image.src}
                    alt={image.alt}
                    className={styles[`${image.className}`]}
                    data-testid={image.testId}
                  />
                )
              )
            })}
        </div>
      )}
    </div>
  )
}
